import { Node, ResolvedPos } from 'prosemirror-model'
import { getContainerBeforePos } from './getContainerBeforePos'

export const getContainerAfterPos = (doc: Node, pos: number): ResolvedPos & { nodeBefore: Node } => {
  const $containerBefore = getContainerBeforePos(doc, pos)

  return doc.resolve(doc.resolve($containerBefore.pos + 1).after()) as ResolvedPos & { nodeBefore: Node }
}
